import React, { useMemo } from 'react';
import './customer-profile-card.scss';
import { Text } from '../../common';
import { Avatar, Switcher } from '../../components';

interface CustomerProfileCardProps {
  name: string;
  mobile: string;
  include: boolean;
  onToggleStatus: () => void;
}

export const CustomerProfileCard: React.FC<CustomerProfileCardProps> = ({
  name,
  mobile,
  include,
  onToggleStatus,
}) => {
  const statusMap: Record<string, { label: string; className: string }> = {
    include: {
      label: 'Active',
      className: 'status-include',
    },
    excluded: {
      label: 'Excluded',
      className: 'status-excluded',
    },
  };

  const statusKey = useMemo(
    () => (include ? 'include' : 'excluded'),
    [include]
  );

  return (
    <div className="profile-card">
      <div className="profile-card-main">
        <Avatar
          profileUrl=""
          title={name}
          size={40}
          style={{ marginRight: '12px' }}
        />
        <div>
          <Text className="profile-card-name font-semibold">{name}</Text>
          <div className="profile-card-sub-info">
            <Text className="profile-card-mobile font-regular">{mobile}</Text>
            <Text>{'•'}</Text>
            <div
              className={`profile-card-status ${statusMap[statusKey]?.className}`}
            >
              <Text className="profile-card-status-label font-regular">
                {statusMap[statusKey]?.label}
              </Text>
            </div>
          </div>
        </div>
      </div>

      <div>
        <Switcher checked={include} onChange={onToggleStatus} />
      </div>
    </div>
  );
};
